import { useLayoutEffect } from 'react';
import Sentry from 'Sentry';

import { useGetUserAnalyticsProfileQuery } from 'services/userAnalyticsProfileService';
import analytics, { setLoggedInUser } from 'utils/analytics';

/**
 * Use this only inside an app and at most once. Currently used to set the
 * currently active app name so that it can be sent with all events to GTM
 */
function TrackingBase({ children }) {
  const { data, isLoading } = useGetUserAnalyticsProfileQuery();

  // Using `useLayoutEffect` so that we can set app as early as possible.
  useLayoutEffect(() => {
    analytics.setEnabled(true);
    setLoggedInUser(data?.data);
    Sentry.enableCapture();
  }, [data]);

  // Added this check because home page analytics was being sent
  // before the user-analytics-profile api ran successfully
  if (!isLoading) return children;
}

export default TrackingBase;
